import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-input-number',
  templateUrl: './custom-input-number.component.html',
  styleUrls: ['./custom-input-number.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputNumberComponent),
      multi: true
    }
  ],
  imports: [CommonModule, FormsModule, InputNumberModule, ReactiveFormsModule, TableModule]
})
export class CustomInputNumberComponent implements ControlValueAccessor {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: number | null) => { };
  onTouched = () => { };
  disabled: boolean = false;
  value: number | null = null;

  @Input() formControlName: string | number | null = null;
  @Input() labelText: string = "";
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Output() onChangeNumber = new EventEmitter<number>();

  changeNumber(event: any) {
    const value = event.target.value
    if (value === null || value === undefined || value === '') {
      this.value = null;
    } else {
      this.value = value;
    }
    this.onChange(value);
    this.onTouched();
    this.onChangeNumber.emit(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectAllText(event: Event) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: number | null): void {
    this.value = value;
  }

}
